export const entry = {
  state: {
    init: {
      description:
        'Точка входа определяет номер, на который нужно совершить звонок, чтобы дозвониться до АТС. Все поступающие на точку входа звонки далее маршрутизируются согласно схеме.'
    },
    ['create-number']: {
      title: 'Добавить внутренний номер'
    }
  },
  input: {
    number_id: {
      label: 'Номер точки входа',
      tooltip: 'Номер точки входа - это номер, на который нужно совершить звонок, чтобы дозвониться до АТС.'

    },

    hide_incoming_number: {
      label: 'Скрыть номер'
    },

    caller_id: {
      label: 'Исходящий номер',
      tooltip: 'Исходящий номер (Caller ID) - это номер, который отобразится у клиента, когда он получит от вас входящий звонок.'
    },

    record: {
      label: 'Записывать звонки'
    },

    calls_only: {
      label: 'Записывать только живые звонки',
      description:
        'Вести записи звонков в которых участвуют 2 и более собеседника. Исключить запись автоматизированных сервисов.'
    },

    links:{
      label: 'Купить пакет услуг'
    }
  }
};
